export const initWebpush = async (params: { userId: string }) => {
  const api = await import('./fcm');

  await api.initFCM(params);
};
